module.exports = __webpack_public_path__ + "media/images/flags/1x1/bmu-1822b7303b2ebf0571baface7c20d40e.svg";